export const UP = 'up'
export const DOWN = 'down'
